import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Navigation from '../Components/Navigation';
import UserInteraction from '../Components/UserInteraction';
import '../Assets/Styles/Admin.css';

const Admin = () => {
  const navigate = useNavigate();
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://tstock.trillionstechsolutions.com/blogs-edits/all');
        
        if (!response.ok) {
          throw new Error('Failed to fetch blog posts');
        }
        
        const result = await response.json();
        
        if (result.success) {
          setBlogPosts(result.data);
        } else {
          throw new Error(result.error || 'Failed to fetch blog posts');
        }
      } catch (error) {
        console.error('Error fetching blog posts:', error);
        setError('Failed to load blog posts. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  const handleEdit = (postId) => {
    navigate(`/edit-blog/${postId}`);
  };

  // Circular loader component
  const CircularLoader = () => (
    <div className="loader-container">
      <div className="circular-loader"></div>
    </div>
  );

  return (
    <div className="app-container">
      <Navigation />
      <div className="admin-content">
        <div className="blog-posts-section">
          <div className="section-header">
            <h2>Blog Posts Management</h2>
            <div className="header-actions">
              <Link to="/blogs" className="view-blogs-btn">
                View Public Blogs
              </Link>
              <Link to="/add-blog" className="new-post-btn">New Post</Link>
            </div>
          </div>
          
          {loading ? (
            <CircularLoader />
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="blog-posts-grid">
              {blogPosts.length > 0 ? (
                blogPosts.map(post => (
                  <div key={post._id} className="blog-post-card">
                    <div className="card-header">
                      <h3>{post.title}</h3>
                      <span className={`status-badge ${post.status.toLowerCase()}`}>
                        {post.status}
                      </span>
                    </div>
                    
                    <div className="card-content">
                      <div className="post-meta">
                        <div className="meta-item">
                          <span className="meta-label">Author:</span>
                          <span className="meta-value">{post.author}</span>
                        </div>
                        <div className="meta-item">
                          <span className="meta-label">Date:</span>
                          <span className="meta-value">{new Date(post.createdAt).toLocaleDateString()}</span>
                        </div>
                        <div className="meta-item">
                          <span className="meta-label">Views:</span>
                          <span className="meta-value">{post.views}</span>
                        </div>
                      </div>
                      
                      <p className="post-excerpt">{post.excerpt || post.content.substring(0, 150) + '...'}</p>
                    </div>
                    
                    <div className="card-actions">
                      <button 
                        className="edit-btn"
                        onClick={() => handleEdit(post._id)}
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-posts-message">
                  <p>No blog posts found. Create your first post!</p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* User Interaction Analytics Section */}
        <UserInteraction />
      </div>
    </div>
  );
};

export default Admin;
